import { render, staticRenderFns } from "./accidentes.vue?vue&type=template&id=268b71ca&"
import script from "./accidentes.vue?vue&type=script&lang=js&"
export * from "./accidentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports